import type { QueryKey } from '@tanstack/react-query';
import type { GetRepositoryParamsFunction } from './types';

export const getRepositoryQueryKey = ((...args) => args) satisfies GetRepositoryParamsFunction<QueryKey>;
